var SubcontractorSortableAttributes;
(function (SubcontractorSortableAttributes) {
    SubcontractorSortableAttributes["NAME"] = "child_tenant_name";
})(SubcontractorSortableAttributes || (SubcontractorSortableAttributes = {}));
export default SubcontractorSortableAttributes;
